import { NgModule } from '@angular/core';
import { NotificationComponent } from './notification/notification.component';
import { MessagingComponent } from './messaging/messaging.component';
import { AlertComponent } from './alert/alert.component';
import { ChatComponent } from './chat/chat.component';
import { CardComponent } from './card/card.component';
import { CommonModule } from '@angular/common';
import { InlineLoaderComponent } from './inline-loader/inline-loader.component';
import { BadgeSeniorityLevelComponent } from './badge-seniority-level/badge-seniority-level.component';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { RouterModule } from '@angular/router';
import { StepComponent } from './stepper/step/step.component';
import { StepContentComponent } from './stepper/step-content/step-content.component';
import { TimeagoPipe } from 'projects/mmb-web-app/src/app/shared/pipes/timeago.pipe';

@NgModule({
  declarations: [
    NotificationComponent, 
    MessagingComponent, 
    AlertComponent, 
    ChatComponent,  
    CardComponent, 
    InlineLoaderComponent, 
    BadgeSeniorityLevelComponent,
    StepComponent, 
    StepContentComponent
  ],
  imports: [
    CommonModule,
    NgbModule,
    RouterModule,
    TimeagoPipe
  ],
  exports: [
    NotificationComponent, 
    MessagingComponent, 
    AlertComponent, 
    ChatComponent, 
    CardComponent,
    InlineLoaderComponent,
    BadgeSeniorityLevelComponent,
    StepComponent, 
    StepContentComponent
  ]
})
export class MmbUiComponentsModule { }
